export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-4xl mx-auto">
        <div className="bg-gradient-to-br from-primary-600 to-primary-800 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-background-50/20 text-background-50 text-xs mb-4">
                <i className="ri-smartphone-line"></i>
                随时随地吃瓜
              </div>
              <h2 className="font-heading text-2xl md:text-3xl text-background-50 mb-4">手机端访问</h2>
              <p className="text-primary-100 text-sm leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                吃瓜爆料网已全面适配移动端，无需下载APP，打开浏览器即可畅享完整爆料体验。
                支持添加到桌面快捷方式，一键直达最新八卦资讯。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <div className="flex items-center gap-2 px-5 py-3 bg-background-50 rounded-lg text-foreground-900 text-sm font-medium">
                  <i className="ri-chrome-line text-lg"></i>
                  <span>浏览器直接访问</span>
                </div>
                <div className="flex items-center gap-2 px-5 py-3 bg-background-50/15 border border-background-50/25 rounded-lg text-background-50 text-sm font-medium">
                  <i className="ri-add-circle-line text-lg"></i>
                  <span>添加到桌面</span>
                </div>
              </div>
            </div>
            <div className="flex-1 flex justify-center p-6 md:p-8">
              <div className="relative w-48 h-80 md:w-56 md:h-96 bg-background-50 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20mobile%20phone%20mockup%20showing%20a%20modern%20dark%20theme%20news%20feed%20with%20warm%20coral%20red%20accent%20colors%2C%20clean%20UI%20design%2C%20sleek%20card%20layout%2C%20editorial%20news%20style%2C%20soft%20warm%20lighting%2C%20minimalist%20aesthetic%2C%20content%20browsing%20interface%2C%20no%20text&width=560&height=960&seq=app-mobile-chigua&orientation=portrait"
                  alt="吃瓜爆料网手机端预览"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}